export type SocialId =
  | 'facebook'
  | 'discord'
  | 'reddit'
  | 'twitter'
  | 'instagram'
  | 'tcgplayer'
  | 'whatnot'

export type SocialOption = {
  id: SocialId
  label: string
  shortLabel: string
  // For Facebook we treat as boolean (no username collected). All others are usernames.
  type: 'boolean' | 'username'
  placeholder?: string
  // Inline SVG glyph keeps things light + theme-able via currentColor.
  glyph: string
}

export const SOCIALS: SocialOption[] = [
  {
    id: 'facebook',
    label: 'Facebook',
    shortLabel: 'FB',
    type: 'boolean',
    glyph:
      'M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5 3.66 9.15 8.44 9.94v-7.03H7.9v-2.91h2.54V9.84c0-2.52 1.49-3.91 3.78-3.91 1.09 0 2.24.2 2.24.2v2.47h-1.26c-1.24 0-1.63.78-1.63 1.57v1.89h2.78l-.44 2.91h-2.34V22c4.78-.79 8.44-4.94 8.44-9.94z',
  },
  {
    id: 'discord',
    label: 'Discord',
    shortLabel: 'Discord',
    type: 'username',
    placeholder: 'username',
    glyph:
      'M20.317 4.369A19.79 19.79 0 0 0 16.558 3.2a14.6 14.6 0 0 0-.66 1.36 18.27 18.27 0 0 0-5.797 0A14.6 14.6 0 0 0 9.44 3.2a19.79 19.79 0 0 0-3.76 1.17C2.51 9.045 1.79 13.58 2.15 18.05a19.93 19.93 0 0 0 6.027 3.05c.486-.67.92-1.39 1.295-2.14a13.6 13.6 0 0 1-2.04-.97c.17-.13.34-.26.5-.4 3.94 1.83 8.21 1.83 12.1 0 .16.14.33.27.5.4-.65.39-1.34.71-2.04.97.375.75.81 1.47 1.295 2.14a19.93 19.93 0 0 0 6.03-3.05c.42-5.21-.71-9.71-3.5-13.68zM9.55 15.36c-1.18 0-2.15-1.1-2.15-2.45s.95-2.45 2.15-2.45c1.21 0 2.18 1.1 2.15 2.45 0 1.35-.95 2.45-2.15 2.45zm4.9 0c-1.18 0-2.15-1.1-2.15-2.45s.95-2.45 2.15-2.45c1.21 0 2.18 1.1 2.15 2.45 0 1.35-.94 2.45-2.15 2.45z',
  },
  {
    id: 'reddit',
    label: 'Reddit',
    shortLabel: 'Reddit',
    type: 'username',
    placeholder: 'username',
    glyph:
      'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5.34 11.5c.03.18.05.36.05.55 0 2.21-2.84 4.01-6.34 4.01-3.5 0-6.34-1.8-6.34-4.01 0-.19.02-.37.05-.55-.5-.27-.84-.79-.84-1.4 0-.88.71-1.59 1.59-1.59.43 0 .81.17 1.1.44 1.07-.66 2.5-1.07 4.06-1.13l.71-3.32c.04-.16.2-.27.36-.23l2.42.51c.17-.34.52-.58.93-.58.56 0 1.02.46 1.02 1.02s-.46 1.03-1.02 1.03c-.55 0-.99-.42-1.01-.96l-2.16-.46-.64 3c1.55.05 2.95.45 4.01 1.12.29-.27.67-.43 1.1-.43.88 0 1.59.71 1.59 1.59 0 .6-.34 1.12-.84 1.4zM7.5 13c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1zm6 3.13c-.59.59-1.5.84-2.49.84s-1.91-.26-2.49-.84c-.16-.16-.16-.41 0-.57.16-.16.41-.16.57 0 .39.39 1.13.66 1.92.66s1.53-.27 1.92-.66c.16-.16.41-.16.57 0 .16.16.16.41 0 .57zm.06-2.13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.44 1-1 1z',
  },
  {
    id: 'twitter',
    label: 'X / Twitter',
    shortLabel: 'X',
    type: 'username',
    placeholder: 'handle',
    glyph:
      'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z',
  },
  {
    id: 'instagram',
    label: 'Instagram',
    shortLabel: 'IG',
    type: 'username',
    placeholder: 'handle',
    glyph:
      'M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.7 3.7 0 0 1-1.38-.9 3.7 3.7 0 0 1-.9-1.38c-.16-.42-.36-1.06-.41-2.23C2.17 15.58 2.16 15.2 2.16 12s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41C8.42 2.17 8.8 2.16 12 2.16zm0 1.62c-3.15 0-3.52.01-4.76.07-1.07.05-1.66.23-2.04.38-.51.2-.88.44-1.27.83-.39.39-.63.76-.83 1.27-.15.39-.33.97-.38 2.05-.06 1.24-.07 1.6-.07 4.76s.01 3.52.07 4.76c.05 1.07.23 1.66.38 2.05.2.51.44.88.83 1.27.39.39.76.63 1.27.83.39.15.97.33 2.04.38 1.24.06 1.61.07 4.76.07s3.52-.01 4.76-.07c1.07-.05 1.66-.23 2.04-.38.51-.2.88-.44 1.27-.83.39-.39.63-.76.83-1.27.15-.39.33-.97.38-2.05.06-1.24.07-1.6.07-4.76s-.01-3.52-.07-4.76c-.05-1.07-.23-1.66-.38-2.05a3.42 3.42 0 0 0-.83-1.27 3.42 3.42 0 0 0-1.27-.83c-.39-.15-.97-.33-2.04-.38-1.24-.06-1.61-.07-4.76-.07zm0 2.76a5.46 5.46 0 1 1 0 10.92 5.46 5.46 0 0 1 0-10.92zm0 9a3.54 3.54 0 1 0 0-7.08 3.54 3.54 0 0 0 0 7.08zm6.95-9.22a1.28 1.28 0 1 1-2.55 0 1.28 1.28 0 0 1 2.55 0z',
  },
  {
    id: 'tcgplayer',
    label: 'TCGplayer',
    shortLabel: 'TCGp',
    type: 'username',
    placeholder: 'account',
    glyph:
      'M3 5.5A2.5 2.5 0 0 1 5.5 3h13A2.5 2.5 0 0 1 21 5.5v13a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 18.5v-13zm5 2.25a.75.75 0 0 0 0 1.5h2.25v6.5a.75.75 0 0 0 1.5 0v-6.5H14a.75.75 0 0 0 0-1.5H8z',
  },
  {
    id: 'whatnot',
    label: 'Whatnot',
    shortLabel: 'Whatnot',
    type: 'username',
    placeholder: 'account',
    glyph:
      'M12 2a10 10 0 1 0 10 10A10.012 10.012 0 0 0 12 2zm-1.3 14.4-3.6-3.6 1.4-1.4 2.2 2.2 5.2-5.2 1.4 1.4z',
  },
]

export type SegmentId =
  | 'first_time_buyer'
  | 'high_intent_buyer'
  | 'collector_only'
  | 'hybrid'
  | 'power_seller'

export type SegmentOption = {
  id: SegmentId
  label: string
}

export const SEGMENTS: SegmentOption[] = [
  { id: 'first_time_buyer', label: 'First-Time Buyer' },
  { id: 'high_intent_buyer', label: 'High-Intent Buyer' },
  { id: 'collector_only', label: 'Collector-Only' },
  { id: 'hybrid', label: 'Hybrid Buyer/Seller' },
  { id: 'power_seller', label: 'Power Seller' },
]
